import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";

import { DataGrid, GridToolbar } from '@mui/x-data-grid'
import { Select, FormControl, MenuItem } from '@mui/material'
import Button from '@mui/material/Button';
import LoadingOverlay from 'react-loading-overlay';

import MuiDialogPasswordReset from '../components/MuiDialogPasswordReset';
import MuiDialogAlert from '../components/MuiDialogAlert';
import MuiDialogUpload from '../components/MuiDialogUpload';

const axios = require('axios').default;

const columns = [
  { field: 'room_id', headerName: 'Room ID', width: 150 },
  { field: 'rc', headerName: 'Residential College',width: 200 },
  { field: 'block', headerName: 'Block', width: 100 },
  { field: 'floor', headerName: 'Floor', width: 100 },
  { field: 'room_type', headerName: 'Type', width: 100 },
  { field: 'password', headerName: 'Password', width: 120 },
  { field: 'status', headerName: 'Status', width: 100 }
]

function Rooms() {

  const [loadingActive, setLoadingActive] = useState(false);
  const [loadingText, setLoadingText] = useState("Loading");

  const [modalHeader, setModalHeader] = useState("");
  const [modalBody, setModalBody] = useState("");
  const [showModal, setShowModal] = useState(false);

  const [showResetPasswordModal, setShowResetPasswordModal] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [fileSelected, setFileSelected] = useState(false);
  const [resultsDivClass, setResultsDivClass] = useState("hidden");

  const [resetBtnDisable, setResetBtnDisable] = useState(true);
  const [floorSelectDisable, setFloorSelectDisable] = useState(true);
  const [blockSelectDisable, setBlockSelectDisable] = useState(true);

  const [showDataDiv, setShowDataDiv] = useState("hidden")

  const [rcList, setRcList] = useState([]);
  const [blockList, setBlockList] = useState([]);
  const [floorList, setFloorList] = useState([]);
  const [resetRoomList, setResetRoomList] = useState([]);

  const [transData, setTransData] = useState([]);

  const [rcValue, setRcValue] = useState("");
  const [blockValue, setBlockValue] = useState("");
  const [floorValue, setFloorValue] = useState("");
  const [roomTypeValue, setRoomTypeValue] = useState("all");
  const [selectedRooms, setSelectedRooms] = useState([]);

  const handleClose = () => {
    setShowModal(false);
    setShowResetPasswordModal(false);
    setShowUploadModal(false);
    setFileSelected(false);
    setResultsDivClass("hidden")
  }
  let navigate = useNavigate();

  // Load the list of available RCs into the Select Menu
  useEffect(() => {
    let url = process.env.REACT_APP_API_SERVER + "/load_parameters";
    setLoadingActive(true);

    axios.post(url, {
      "api_user": JSON.parse(localStorage.getItem('user')),
      "parameters": "RcList"
    })
      .then(function (response) {

        if (response.data.status === "API_AUTH_ERROR") {
          // Force user to re-login if unable to autheticate with the API
          navigate("/logout")
        }

        setRcList(response.data)
        if (response.data.length > 0) {
          setRcValue("all_rcs")
        }
        setLoadingActive(false)
      })
      .catch(function (error) {
        setModalHeader("Error loading RCs")
        setModalBody(error)
        setShowModal(true)
      });
  }, [])

  // Load the list of available Blocks into the Select Menu based on the RC selected
  useEffect(() => {
    let url = process.env.REACT_APP_API_SERVER + "/load_parameters";
    setLoadingActive(true);

    if (rcValue === "all_rcs") { // Disable selecting of Blocks and floors 
      setBlockSelectDisable(true)
      setBlockValue("all_blocks")
      setLoadingActive(false)
    }
    else {
      axios.post(url, {
        "api_user": JSON.parse(localStorage.getItem('user')),
        "parameters": "BlockList",
        "rc_code": { rcValue }
      })
        .then(function (response) {

          if (response.data.status === "API_AUTH_ERROR") {
            // Force user to re-login if unable to autheticate with the API
            navigate("/logout")
          }
          
          
          setBlockList(response.data)
          setLoadingActive(false)
          if (response.data.length > 0) {
            setBlockValue("all_blocks")
            setBlockSelectDisable(false)
          }
        })
        .catch(function (error) {
          setModalHeader("Error loading Block List")
          setModalBody(error)
          setShowModal(true)
        });
    }
  }, [rcValue])

  // Load the list of available Floors into the Select Menu based on the RC + Block selected
  useEffect(() => {
    let url = process.env.REACT_APP_API_SERVER + "/load_parameters";
    setLoadingActive(true);

    if (blockValue === "all_blocks") { // Disable selecting of floors if the user selects all blocks
      setFloorSelectDisable(true)
      setFloorValue("all_floors")
      setLoadingActive(false)
    }
    else {
      axios.post(url, {
        "api_user": JSON.parse(localStorage.getItem('user')),
        "parameters": "FloorList",
        "rc_code": { rcValue },
        "block_code": { blockValue }
      })
        .then(function (response) {
          if (response.data.status === "API_AUTH_ERROR") {
            // Force user to re-login if unable to autheticate with the API
            navigate("/logout")
          }

          setFloorList(response.data)
          if (response.data.length > 0) {
            setFloorValue("all_floors")
            setFloorSelectDisable(false)
          }
          setLoadingActive(false)
        })
        .catch(function (error) {
          setModalHeader("Error loading Floor List")
          setModalBody(error)
          setShowModal(true)
        });
    }

  }, [blockValue])

  function genBtnClick() {
    let post_data = {
      "api_user": JSON.parse(localStorage.getItem('user'))
    }
      post_data.parameters = "RoomReset"
      post_data.rc_code = rcValue
      post_data.block_code = blockValue
      post_data.floor_code = floorValue
      post_data.room_type = roomTypeValue

    let url = process.env.REACT_APP_API_SERVER + "/gen_report";
    setLoadingActive(true);

    axios.post(url, post_data)
      .then(function (response) {
        if (response.data.status === "API_AUTH_ERROR") {
          // Force user to re-login if unable to autheticate with the API
          navigate("/logout")
        }


        let data = response.data;

        if (data.status === "OK") {
          let tmp_array = []

          data.trans_data.map((trans) => {
            let tmp = {};
            tmp.id = trans.room_id
            tmp.room_id = trans.room_id
            tmp.password = trans.password
            tmp.room_type = trans.room_type

            if (trans.active === 1) {
              tmp.status = "Active"
            }
            else{
              tmp.status = "Disabled"
            }

            tmp.rc = getRcName(trans.rc_code)
            tmp.block = getBlockName(trans.block_code)
            tmp.floor = getFloorName(trans.floor_code)

            tmp_array.push(tmp);
          })
          setTransData(tmp_array)
          setShowDataDiv("")
        }

        setLoadingActive(false)
      })
      .catch(function (error) {
        setModalHeader("Error generating report")
        setModalBody(error)
        setShowModal(true)
      });

  }

  function resetBtnClick(){
    let rooms = []

    for (let index = 0; index < selectedRooms.length; index++) {
      rooms.push(selectedRooms[index])
    }

    setResetRoomList(rooms)
    setShowResetPasswordModal(true)
  }

  function importCsvBtnClick(){
    setShowUploadModal(true)
  }

  function doResetPassword(){

    let post_data = {
      "api_user": JSON.parse(localStorage.getItem('user'))
    }
    post_data.parameters = "RoomPasswordReset"
    post_data.rooms = resetRoomList

    let url = process.env.REACT_APP_API_SERVER + "/reset_password";
    setShowModal(false);
    setLoadingActive(true);

    axios.post(url, post_data)
      .then(function (response) {
        if (response.data.status === "API_AUTH_ERROR") {
          // Force user to re-login if unable to autheticate with the API
          navigate("/logout")
        }

        setLoadingActive(false)
        setShowResetPasswordModal(false)
        genBtnClick();
      })
      .catch(function (error) {
        setModalHeader("Error Resetting Password")
        setModalBody(error)
        setShowModal(true)
      });
  }

  function doUploadFile(){
    console.log("uploading file");
  }

  function checkSelected(selected_rooms){
    if (selected_rooms.length === 0) {
      setResetBtnDisable(true)
    } else {
      setResetBtnDisable(false)      
    }

    setSelectedRooms(selected_rooms)
  }

  function updateForm(e) {

    if (e.target.name === "rc") {
      setRcValue(e.target.value)
    }

    if (e.target.name === "block") {
      setBlockValue(e.target.value)
    }

    if (e.target.name === "floor") {
      setFloorValue(e.target.value)
    }

    if (e.target.name === "room_type") {
      setRoomTypeValue(e.target.value)
    }

  }

  function getRcName(rc_code){
    for (let index = 0; index < rcList.length; index++) {
      if (rcList[index].rc_code === rc_code) {
        return rcList[index].description
      }      
    }
  }

  function getBlockName(block_code){
    for (let index = 0; index < blockList.length; index++) {
      if (blockList[index].block_code === block_code) {
        return blockList[index].description
      }      
    }
  }

  function getFloorName(floor_code){
    for (let index = 0; index < floorList.length; index++) {
      if (floorList[index].floor_code === floor_code) {
        return floorList[index].description
      }      
    }
  }


  return (
    <div align="left" style={{ height: "100%" }}>
      <LoadingOverlay
        active={loadingActive}
        spinner
        text={loadingText}
        className="spinner_div"
      >
        <div className="form_area">

          <div>
            <table>
              <tr>
                <td valign="top">
                  <div>
                    <table>
                      <tr>
                        <td>
                          <div className="form-labels">RC/Hall</div>
                          <FormControl fullWidth>
                            <Select
                              id="rc"
                              name="rc"
                              label="Select RC"
                              value={rcValue}
                              variant="outlined"
                              onChange={updateForm}
                              sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                ' & .MuiSelect-select': { fontSize: 14 }
                              }}
                            >
                              <MenuItem key="0" value="all_rcs">All RCs/Halls</MenuItem>
                              {
                                rcList.map(rc => {
                                  return <MenuItem key={rc.rc_code} value={rc.rc_code}>
                                    {rc.description}
                                  </MenuItem>
                                })
                              }
                            </Select>
                          </FormControl>
                        </td>
                        <td width="15px"></td>
                        <td>
                          <div className="form-labels">Block</div>
                          <FormControl fullWidth>
                            <Select
                              id="block"
                              name="block"
                              label="Select Block"
                              onChange={updateForm}
                              value={blockValue}
                              disabled={blockSelectDisable}
                              style={{ width: "150px" }}
                              sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                ' & .MuiSelect-select': { fontSize: 14 }
                              }}
                            >
                              <MenuItem key="0" value="all_blocks">All Blocks</MenuItem>
                              {
                                blockList.map(block => {
                                  return <MenuItem key={block.block_code} value={block.block_code}>
                                    {block.description}
                                  </MenuItem>
                                })
                              }
                            </Select>
                          </FormControl>

                        </td>
                        <td width="15px"></td>
                        <td>
                          <div className="form-labels">Floor</div>
                          <FormControl fullWidth>
                            <Select
                              id="floor"
                              name="floor"
                              label="Select Floor"
                              onChange={updateForm}
                              value={floorValue}
                              disabled={floorSelectDisable}
                              style={{ width: "150px" }}
                              sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                ' & .MuiSelect-select': { fontSize: 14 }
                              }}
                            >
                              <MenuItem key="0" value="all_floors">All Floors</MenuItem>
                              {
                                floorList.map(floor => {
                                  return <MenuItem key={floor.floor_code} value={floor.floor_code}>
                                    {floor.description}
                                  </MenuItem>
                                })
                              }
                            </Select>
                          </FormControl>
                        </td>
                        <td width="15px"></td>
                        <td>
                          <div className="form-labels">Room Type</div>
                          <FormControl fullWidth>
                            <Select
                              id="room_type"
                              name="room_type"
                              label="Select Room Type"
                              // size="small"
                              onChange={updateForm}
                              value={roomTypeValue}
                              style={{ width: "150px" }}
                              sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                ' & .MuiSelect-select': { fontSize: 14 }
                              }}
                            >
                              <MenuItem key="0" value="all">Show All</MenuItem>
                              <MenuItem key="1" value="students">Students</MenuItem>
                              <MenuItem key="2" value="non_students">Non Students</MenuItem>
                            </Select>
                          </FormControl>
                        </td>
                        <td width="15px"></td>
                      </tr>
                    </table>
                  </div>
                </td>

                <td width="10px"></td>
                <td>
                  <Button
                    variant="contained"
                    color="success"
                    onClick={genBtnClick}
                    sx={{ width: 100, height: 50 }}
                    style={{ marginTop: "20px" }}
                  >
                    Generate
                  </Button>

                </td>
                <td width="10px"></td>
                <td>
                  <Button
                    variant="contained"
                    color="error"
                    onClick={resetBtnClick}
                    disabled={resetBtnDisable}
                    sx={{ width: 180, height: 50 }}
                    style={{ marginTop: "20px" }}
                  >
                    Reset Password
                  </Button>
                </td>
                <td width="10px"></td>
                <td>
                  <Button
                    variant="contained"
                    color="warning"
                    onClick={importCsvBtnClick}
                    sx={{ width: 120, height: 50 }}
                    style={{ marginTop: "20px" }}
                  >
                    Import CSV
                  </Button>
                </td>
              </tr>
            </table>

            <div style={{ height: "30px" }}></div>

            <div className={showDataDiv}>
              <div style={{ height: 700, width: '100%' }}>
                <DataGrid
                  rows={transData}
                  columns={columns}
                  pageSize={100}
                  disableVirtualization
                  components={{ Toolbar: GridToolbar }}
                  checkboxSelection={true}
                  onSelectionModelChange={checkSelected}
                  sx={{
                    '& .MuiTablePagination-selectLabel': { paddingTop: '15px' },
                    '& .MuiTablePagination-displayedRows': { paddingTop: '15px' },
                    '& .MuiDataGrid-cell': { fontSize: 12 },
                    '& .MuiDataGrid-columnHeader': { fontSize: 12 }
                  }}
                />
              </div>
            </div>
          </div>

          <MuiDialogAlert
            showModal={showModal}
            handleClose={handleClose}
            bodyContent={modalBody}
            title={modalHeader}
            bodyClass="whitespace"
          />

          <MuiDialogPasswordReset
            showModal={showResetPasswordModal}
            handleClose={handleClose}
            handleConfirm={doResetPassword}
            roomList={resetRoomList}
          />

          <MuiDialogUpload
            showModal={showUploadModal}
            handleClose={handleClose}
            fileSelected={fileSelected}
            setFileSelected={setFileSelected}
            handleConfirm={doUploadFile}
            resultsDivClass={resultsDivClass}
            setResultsDivClass={setResultsDivClass}
          />

        </div>
      </LoadingOverlay>
    </div>
  )
}

export default Rooms